<img class="search-icon" src="/assets/images/icons/search.svg" alt="{{ 'general.alt.SEARCH' | translate }}"/>
<mat-form-field class="search-input">
    <mat-label>{{ 'search.FILTER' | translate }}</mat-label>
    <input matInput placeholder="{{ 'search.PLACEHOLDER' | translate }}" #input type="text" name="search" id="search" [(ngModel)]="searchPattern">
  </mat-form-field>